define(['jquery', 'core/templates', 'core/url'
], function($, templates, moodleUrl) {
    return {
        initTrainerReg: function() {
            var siteurl = moodleUrl.relativeUrl('');
            templates.render('local_custom_auth/modal_addtrainerregistration', {siteurl: siteurl}).done(function(html, js) {
                $('body').append(html);
                templates.runTemplateJS(js);
                $('#trainerModal').modal('show');
            }).fail(function() {
            });
        },
        initIndustryReg: function() {
            var siteurl = moodleUrl.relativeUrl('');
            templates.render('local_custom_auth/modal_addindustryregistration', {siteurl: siteurl}).done(function(html, js) {
                $('body').append(html);
                templates.runTemplateJS(js);
                $('#industryModal').modal('show');
            }).fail(function() {
            });
        },
        initCandidateReg: function() {
            var siteurl = moodleUrl.relativeUrl('');
            templates.render('local_custom_auth/modal_addcandidateregistration', {siteurl: siteurl}).done(function(html, js) {
                $('body').append(html);
                templates.runTemplateJS(js);
                $('#candidateModal').modal('show');
            }).fail(function() {
            });
        },
        initUniversityReg: function() {
            var siteurl = moodleUrl.relativeUrl('');
            templates.render('local_custom_auth/modal_addcollegeregistration', {siteurl: siteurl}).done(function(html, js) {
                $('body').append(html);
                templates.runTemplateJS(js);
                $('#universityModal').modal('show');
            }).fail(function(e) {
            });
        },
        init: function() {
            var siteurl = moodleUrl.relativeUrl('');
            $(document).on('click','#modalcandidate', function(e) {
                e.preventDefault();
                if ($('#candidateModal').length == 0) {
                    templates.render('local_custom_auth/modal_addcandidateregistration', {siteurl: siteurl}).done(function(html, js) {
                        $('body').append(html);
                        templates.runTemplateJS(js);
                        $('#candidateModal').modal('show');
                    }).fail(function(e) {
                    });
                } else {
                    $('#candidateModal').modal('show');
                }
            });
            $(document).on('click','#modalindustry', function(e) {
                e.preventDefault();
                if ($('#industryModal').length == 0) {
                    templates.render('local_custom_auth/modal_addindustryregistration', {siteurl: siteurl}).done(function(html, js) {
                        $('body').append(html);
                        templates.runTemplateJS(js);
                        $('#industryModal').modal('show');
                    }).fail(function(e) {
                    });
                } else {
                    $('#industryModal').modal('show');
                }

            });
            $(document).on('click','#modaluniversity', function(e) {
                e.preventDefault();
                if ($('#universityModal').length == 0) {
                    templates.render('local_custom_auth/modal_addcollegeregistration', {siteurl: siteurl}).done(function(html, js) {
                        $('body').append(html);
                        templates.runTemplateJS(js);
                        $('#universityModal').modal('show');
                    }).fail(function(e) {
                    });
                } else {
                    $('#universityModal').modal('show');
                }
            });
            $(document).on('click','#modaltrainer', function(e) {
                if ($('#trainerModal').length == 0) {
                    templates.render('local_custom_auth/modal_addtrainerregistration', {siteurl: siteurl}).done(function(html, js) {
                        $('body').append(html);
                        templates.runTemplateJS(js);
                        $('#trainerModal').modal('show');
                    }).fail(function(e) {
                    });
                } else {
                    $('#trainerModal').modal('show');
                }
            });
            // Home page jobs redirection.
            $(document).on("click", ".jobapplyredirection", function (e) {
                var url1 = M.cfg.wwwroot + '/local/marketplace/setsession.php';
                e.preventDefault();
                var jobid = $(this).data('jobid');

                if ($(this).data("id") == 1 || $(this).data("normal") == 1) {
                    $(".pidpopup").val(jobid);
                    $.post(M.cfg.wwwroot + "/local/marketplace/setsession.php", { jobid: jobid + "|1" });
                } else {
                    if ($("input[name=optradio]:checked").length == 0) {
                        swal({
                            icon: "error",
                            title: "Select a batch to proceed",
                            timer: 1500
                        });
                    } else {
                        $("#myBatchModal").modal("hide");
                        $("#myfreeBatch").modal("hide");
                        $("#signinModal").modal("show");
                        $("#signinModal").modal({ backdrop: "static", keyboard: false });
                        var batch = $("input[name=optradio]:checked").val();
                        $(".pidpopup").val(jobid + "|" + batch);
                        $.post(M.cfg.wwwroot + "/local/marketplace/setsession.php", { jobid: jobid + "|" + batch });
                    }
                }
            });
            // Home page jobs category redirection.
            $(document).on("click", ".jobcategory", function (e) {
                var url1 = M.cfg.wwwroot + '/local/marketplace/setsession.php';
                e.preventDefault();
                var catid = $(this).data('catid');
                if ($(this).data("id") == 1 || $(this).data("normal") == 1) {

                    $(".pidpopup").val(catid);
                    $.post(M.cfg.wwwroot + "/local/marketplace/setsession.php", { catid: catid });
                } else {
                    if ($("input[name=optradio]:checked").length == 0) {
                        swal({
                            icon: "error",
                            title: "Select a batch to proceed",
                            timer: 1500
                        });
                    } else {
                        $("#myBatchModal").modal("hide");
                        $("#myfreeBatch").modal("hide");
                        $("#signinModal").modal("show");
                        $("#signinModal").modal({ backdrop: "static", keyboard: false });
                        var batch = $("input[name=optradio]:checked").val();
                        $(".pidpopup").val(catid + "|" + batch);
                        $.post(M.cfg.wwwroot + "/local/marketplace/setsession.php", { catid: catid });
                    }
                }
            });
            // Home Page FAQ
            $(document).on("click", "#faqid", function(e) {
                if ($('#faq_modal').length == 0) {
                    templates.render('theme_remui/faq', {siteurl: siteurl}).done(function(html, js) {
                        $('body').append(html);
                        templates.runTemplateJS(js);
                        $('#faq_modal').modal('show');
                    }).fail(function(e) {
                    });
                } else {
                    $('#faq_modal').modal('show');
                }
            });
            $('.signinform-mobile #showpwd').on('change', function(e) {
                var parent  = $(e.currentTarget).parents('.signinform-mobile');
                if ($(e.currentTarget).prop('checked')) {
                    parent.find('#password').attr('type', 'text');
                } else {
                    parent.find('#password').attr('type', 'password');
                }
            });
            $(".eye-icon").click(function() {
                var passwordField = $(".pwd");
                var icon = $("#togglePassword");
                if (passwordField.attr("type") === "password") {
                    icon.removeClass("fa-eye-slash").addClass("fa-eye");
                    passwordField.removeAttr("type").attr("type", "text");
                } else {
                    icon.removeClass("fa-eye").addClass("fa-eye-slash");
                    passwordField.removeAttr("type").attr("type", "password");
                }
            }); 
        }
    };
});
